import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Login from "./components/Login";
import AuthCallback from "./components/AuthCallback";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import SubscriptionSuccess from "./components/SubscriptionSuccess";
import SubscriptionCancel from "./components/SubscriptionCancel";
import PayPalSuccess from "./components/PayPalSuccess";
import Settings from "./components/Settings";
import { Toaster } from "./components/ui/toaster";
import { analytics } from "./api";

// Generate a persistent session ID for visitor tracking
const getVisitorSessionId = () => {
  let sid = sessionStorage.getItem('tb_visitor_sid');
  if (!sid) {
    sid = 'vs_' + Math.random().toString(36).substr(2, 12);
    sessionStorage.setItem('tb_visitor_sid', sid);
  }
  return sid;
};

function AppRouter() {
  const location = useLocation();
  
  // Track page visits
  useEffect(() => {
    analytics.trackVisit({
      path: location.pathname,
      referrer: document.referrer,
      screen_width: window.innerWidth,
      session_id: getVisitorSessionId(),
      is_authenticated: !!(localStorage.getItem('session_token') || sessionStorage.getItem('session_token')),
    });
  }, [location.pathname]);
  
  // Check if we're in auth callback flow
  if (location.pathname === '/auth/callback' || location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription/success"
          element={
            <ProtectedRoute>
              <SubscriptionSuccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription/cancel"
          element={
            <ProtectedRoute>
              <SubscriptionCancel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscription/paypal/success"
          element={
            <ProtectedRoute>
              <PayPalSuccess />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
